let $ = jQuery;
let breakpoints = require('../utilities/breakpoints');

class FooterIconList {
  constructor() {
    this.openItemClass = 'icon-list__item--open';
    this.openTeaserClass = 'paragraph--teaser-with-header--current';

    // Accordion with Teasers (Footer)
    this.$wrapperWithTeasers = $('.footer--middle__wrapper');
    this.$iconListTeasers = this.$wrapperWithTeasers.find('.icon-list');
    this.$iconListItems = this.$iconListTeasers.find('.icon-list__item');
    this.$iconListItemsLink = this.$iconListTeasers.find('.footer-abilitylab');
    this.$iconListIcons = $('.accordion__icon');
    this.$iconListLinks = $('.icon-list__link');
    this.$teasers = $('.paragraph--teaser-with-header');

    // Accordion without Teasers (How we Heal)
    this.$wrapper = $('.accordion__list');
    this.$iconListAccordion = this.$wrapper.find('.icon-list');
    this.$iconListAccordionItems =
      this.$iconListAccordion.find('.icon-list__item');
    this.$iconListItemsLinkAccordion =
      this.$iconListAccordion.find('.footer-abilitylab');
    this.$iconListAccordionLinks =
      this.$iconListAccordion.find('.icon-list__link');

    // Accordion with Teasers (Footer)
    this.$currentTeaserItem =
      this.$iconListTeasers.find('.icon-list__item--open');
    if (!this.$currentTeaserItem.length) {
      this.$currentTeaserItem =
        this.$iconListTeasers.find('.icon-list__item').first();
      this.$currentTeaserItem.addClass(this.openItemClass);
    }

    this.$currentTeaser = $('.paragraph--teaser-with-header--current');
    if (!this.$currentTeaser.length) {
      this.$currentTeaser = this.$teasers.first();
      this.$currentTeaser.addClass(this.openTeaserClass);
    }

    // Accordion without Teasers (How we Heal)
    this.$currentItem = this.$iconListAccordion.find('.icon-list__item--open');
    if (this.$currentItem.length) {
      this.$currentItem.removeClass(this.openItemClass);
    }

    this.initializeIconListState(this.$iconListItemsLink);
    this.initializeIconListState(this.$iconListItemsLinkAccordion);
    this.setActiveState();
    this.enableEvents();
  }

  enableEvents() {
    this.$iconListItems.on('click', (e) =>
      this.handleIconListItemClick(e, 'with-teasers')
    );
    this.$iconListAccordionItems.on('click', (e) =>
      this.handleIconListItemClick(e, 'no-teasers')
    );

    // Accordion with teasers
    this.$iconListItemsLink
      .add(this.$iconListIcons)
      .on('mouseenter', (e) => this.handleIconListItemHoverBlur(e, 'hover'));
    this.$iconListItemsLink
      .add(this.$iconListIcons)
      .on('mouseleave', (e) => this.handleIconListItemHoverBlur(e, 'blur'));
    this.$iconListItemsLink
      .add(this.$iconListIcons)
      .on('focusin', (e) => this.handleIconListItemHoverBlur(e, 'hover'));
    this.$iconListItemsLink
      .add(this.$iconListIcons)
      .on('focusout', (e) => this.handleIconListItemHoverBlur(e, 'blur'));

    // Accordion without teasers
    this.$iconListItemsLinkAccordion
      .add(this.$iconListIcons)
      .on('mouseenter', (e) => this.handleIconListItemHoverBlur(e, 'hover'));
    this.$iconListItemsLinkAccordion
      .add(this.$iconListIcons)
      .on('mouseleave', (e) => this.handleIconListItemHoverBlur(e, 'blur'));
    this.$iconListItemsLinkAccordion
      .add(this.$iconListIcons)
      .on('focusin', (e) => this.handleIconListItemHoverBlur(e, 'hover'));
    this.$iconListItemsLinkAccordion
      .add(this.$iconListIcons)
      .on('focusout', (e) => this.handleIconListItemHoverBlur(e, 'blur'));
  }

  handleIconListItemClick(e, variation) {
    if (breakpoints.current !== 'small' && breakpoints.current !== 'medium') {
      this.updateContent(e, variation);
    }
  }

  initializeIconListState($items) {
    $items.find('.accordion__icon').each(function () {
      const iconSrc = $(this).data('src');
      const imagesPath = '/themes/custom/abilitylab_theme/dist/images';
      const hoverSrc = `${imagesPath}/gifs/${iconSrc}-First_Movement.gif`;
      const hoverStaticSrc = `${imagesPath}/png/${iconSrc}-First_Movement.png`;
      const blurSrc = `${imagesPath}/gifs/${iconSrc}-Second_Movement.gif`;
      let hoverAnimate =
        `<img class='accordion__icon accordion__icon--hover-animate'
        data-src='${iconSrc}' src='${hoverSrc}' alt='${iconSrc} hover animate' />`;
      let hoverStatic =
        `<img class='accordion__icon accordion__icon--hover-static'
        data-src='${iconSrc}' src='${hoverStaticSrc}' alt='${iconSrc} hover static' />`;
      let blurAnimate =
        `<img class='accordion__icon accordion__icon--blur-animate'
        data-src='${iconSrc}' src='${blurSrc}' alt='${iconSrc} blur animate' />`;
      $(this).attr('alt', `${iconSrc} blur static`)
      $(this).addClass('accordion__icon--blur-static');
      $(hoverAnimate).insertAfter(this);
      $(hoverStatic).insertAfter(this);
      $(blurAnimate).insertAfter(this);
    });

    this.changeIconState($items, -1);
  }

  // Change active image (animted/static)
  changeIconState = ($el, state) => {
    try {
      const $blurStatic = $el.find('.accordion__icon--blur-static');
      const $hoverAnimate = $el.find('.accordion__icon--hover-animate');
      const $blurAnimate = $el.find('.accordion__icon--blur-animate');
      const $hoverStatic = $el.find('.accordion__icon--hover-static');
      const hoverSrc = $hoverAnimate.attr('src').split('?');
      const blurSrc = $blurAnimate.attr('src').split('?');
      const animationDelay = 400;

      switch (state) {
        case 0:
          // adding random query to reset the animation
          $hoverAnimate.attr('src', `${hoverSrc[0]}?q=` + Math.random());
          // adding delay to show gif to avoid blinking
          setTimeout(function () {
            $blurStatic.css('display', 'none');
            $hoverAnimate.css('display', 'inline-block');
            $blurAnimate.css('display', 'none');
            $hoverStatic.css('display', 'none');
          }, animationDelay);
          break;
        case 1:
          // adding random query to reset the animation
          $blurAnimate.attr('src', `${blurSrc[0]}?q=` + Math.random());
          // adding delay to show gif to avoid blinking
          setTimeout(function () {
            $blurStatic.css('display', 'none');
            $hoverAnimate.css('display', 'none');
            $blurAnimate.css('display', 'inline-block');
            $hoverStatic.css('display', 'none');
          }, animationDelay);
          break;
        case 2:
          $blurStatic.css('display', 'none');
          $hoverAnimate.css('display', 'none');
          $blurAnimate.css('display', 'none');
          $hoverStatic.css('display', 'inline-block');
          break;
        default:
          $blurStatic.css('display', 'inline-block');
          $hoverAnimate.css('display', 'none');
          $blurAnimate.css('display', 'none');
          $hoverStatic.css('display', 'none');
      }
    }
    // eslint-disable-next-line no-empty
    catch { }
  };

  handleIconListItemHoverBlur(e, $action) {
    let $target = $(e.currentTarget);
    const $blurStatic = $target.find('.accordion__icon--blur-static');
    const $hoverAnimate = $target.find('.accordion__icon--hover-animate');
    const $blurAnimate = $target.find('.accordion__icon--blur-animate');
    const $hoverStatic = $target.find('.accordion__icon--hover-static');
    const animationDuration = 1600;

    const animate = (state) => {
      $target.attr('data-is-animating', true);
      this.changeIconState($target, state);
      setTimeout(() => {
        if (state == 0) {
          this.changeIconState($target, 2);
        }
        else if (state == 1) {
          this.changeIconState($target, -1);
        }
        $target.removeAttr('data-is-animating');
      }, animationDuration);
    };

    if ($target.attr('data-has-next-animation')) {
      return false;
    }

    if (!$target.attr('data-is-animating')) {
      if (
        $action === 'hover' &&
        $hoverAnimate.css('display') == 'none' &&
        $hoverStatic.css('display') == 'none' &&
        $blurAnimate.css('display') == 'none'
      ) {
        animate(0);
      }
      else if (
        $action === 'blur' &&
        $blurAnimate.css('display') == 'none' &&
        $blurStatic.css('display') == 'none' &&
        $hoverAnimate.css('display') == 'none'
      ) {
        animate(1);
      }
    }
    else {
      if ($hoverAnimate.css('display') != 'none' && $action === 'blur') {
        $target.attr('data-has-next-animation', true);
        setTimeout(function () {
          animate(1);
          $target.removeAttr('data-has-next-animation');
        }, animationDuration);
      }
    }
  }

  handleSmallClick(e) {
    let $target = $(e.currentTarget);
    let href = $target.find('.icon-list__link').attr('href');
    window.location = href;
  }

  updateContent(e, variation) {
    let $target = $(e.currentTarget);


    if ($target.hasClass(this.openItemClass)) {
      return;
    }
    else {
      e.preventDefault();

      if (variation === 'with-teasers') {
        this.$currentTeaserItem.removeClass(this.openItemClass);
        this.$currentTeaserItem = $target;

        let index = this.$iconListItems.index(this.$currentTeaserItem[0]);
        let $targetTeaser = $(this.$teasers[index]);

        this.$currentTeaser.removeClass(this.openTeaserClass);
        this.$currentTeaser = $targetTeaser;
      }
      else {
        this.$currentItem.removeClass(this.openItemClass);
        this.$currentItem = $target;
      }

      this.setActiveState();

      return false;
    }
  }

  setActiveState() {
    if (this.$currentTeaser) {
      this.$currentTeaser.addClass(this.openTeaserClass);
    }

    this.$currentTeaserItem.addClass(this.openItemClass);
    this.$currentItem.addClass(this.openItemClass);

    this.setLinkTabbing();
  }

  setLinkTabbing() {
    $(this.$iconListAccordionLinks, this.$iconListLinks).each((index, elem) => {
      elem.tabIndex = -1;

      if ($(elem).parent().hasClass(this.openItemClass)) {
        elem.tabIndex = 0;
      }
    });
  }
}

if (typeof Drupal === 'undefined') {
  // Initialize for Styleguide
  $(document).ready(() => {
    let footerIconList = new FooterIconList();
  });
}
else {
  module.exports = {
    attach: function (context, settings) {
      let footerIconList = new FooterIconList();
    },
  };
}
